/**
 * Audio Element
 */

import type { ElementDefinition } from '@ai-content-hub/content-kit';
import { audioElementSchema, type AudioElementData } from './schema';
import { AudioEdit } from './AudioEdit';
import { AudioPlayer } from './AudioPlayer';

export { audioElementSchema, type AudioElementData };
export { AudioEdit };
export { AudioPlayer };

export const audioElement: ElementDefinition<AudioElementData, void> = {
    schema: audioElementSchema,
    EditComponent: AudioEdit as any,
    PlayerComponent: AudioPlayer as any,
};
